// extracted by mini-css-extract-plugin
module.exports = {"markdownBody":"ContentPage_markdownBody__Yh4qh"};